import React, { FC, ReactNode, useEffect } from 'react';
import { AuthHooks, UserHooks } from 'common/hooks';
import { useAppSelector } from 'app/store/store.hooks';
import { SelectCityModal } from 'entities/City/components';
import { selectCurrentUser } from 'entities/User/User.slice';
import { CityHooks } from 'entities/City/City.hooks';

interface IComponentProps {
  children: ReactNode;
}

export const CityProvider: FC<IComponentProps> = ({ children }) => {
  const currentUser = useAppSelector(selectCurrentUser);

  const { isSeller } = AuthHooks.useIsSeller();
  const { isSuperAdmin } = UserHooks.useCurrentUserRole();
  const { openSelectCityModal, props: selectCityModalProps } = CityHooks.useSelectCityModal();

  const shouldSelectCity = !isSeller && !isSuperAdmin && !!currentUser && !currentUser?.city;

  useEffect(() => {
    if (!shouldSelectCity) {
      return;
    }

    openSelectCityModal();
  }, [shouldSelectCity]);

  return (
    <>
      {children}

      <SelectCityModal {...selectCityModalProps} allowCancel={false} />
    </>
  );
};
